var _circle, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRedIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9550_62475)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#D32F2F"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9550_62475",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 42,
    height: 42
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 42,
    height: 42,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9550_62475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7 37.1442L29 30.8442L35.3 37.1442L37.1442 35.3L30.8442 29L37.1442 22.7L35.3 20.8558L29 27.1558L22.7 20.8558L20.8558 22.7L27.1558 29L20.8558 35.3L22.7 37.1442ZM29.0029 45.6249C26.7035 45.6249 24.5422 45.1886 22.519 44.3159C20.4957 43.4432 18.7358 42.2589 17.2391 40.763C15.7425 39.267 14.5576 37.5078 13.6846 35.4855C12.8115 33.4631 12.375 31.3023 12.375 29.0029C12.375 26.7035 12.8113 24.5422 13.684 22.519C14.5567 20.4957 15.741 18.7358 17.2369 17.2391C18.7329 15.7425 20.4921 14.5576 22.5145 13.6846C24.5368 12.8115 26.6976 12.375 28.997 12.375C31.2964 12.375 33.4577 12.8113 35.481 13.684C37.5042 14.5567 39.2642 15.741 40.7608 17.2369C42.2575 18.7329 43.4423 20.4921 44.3153 22.5145C45.1884 24.5368 45.6249 26.6976 45.6249 28.997C45.6249 31.2964 45.1886 33.4577 44.3159 35.481C43.4433 37.5042 42.2589 39.2642 40.763 40.7608C39.267 42.2574 37.5078 43.4423 35.4855 44.3153C33.4631 45.1884 31.3023 45.6249 29.0029 45.6249ZM29 43C32.9083 43 36.2187 41.6437 38.9312 38.9312C41.6437 36.2187 43 32.9083 43 29C43 25.0916 41.6437 21.7812 38.9312 19.0687C36.2187 16.3562 32.9083 15 29 15C25.0916 15 21.7812 16.3562 19.0687 19.0687C16.3562 21.7812 15 25.0916 15 29C15 32.9083 16.3562 36.2187 19.0687 38.9312C21.7812 41.6437 25.0916 43 29 43Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9550_62475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 58,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRedIcon);
export default __webpack_public_path__ + "static/media/delete-red-icon.ef1465c6b673c96544ff1a8da3cf95dc.svg";
export { ForwardRef as ReactComponent };